import FileModel from './globals/FileModel';

export default class ReportPdfModel extends FileModel {
  static get path() {
    return '/backend/reports/{id}/pdf/{locale}';
  }
}
